export default {
  improvementplans: {
    title: 'Plan zur Verbesserung',
    high: 'Hoch',
    middle: 'Mittel',
    low: 'Niedrig',
    exceed: 'Überschreiten',
    policy: 'Richtlinie',
    measure: 'Aktion',
    result: 'Ergebnis',
    currently_supporting: 'In Bearbeitung',
    completion: 'Abgeschlossen',
    ended: 'Unvollständig',
    risk: 'Risiko',
    thema: "@:{'common.esg.category'}",
    improvement_plan: 'Plan zur Verbesserung',
    deadline_for_completion: 'Deadline',
    message_count: 'Nachricht',
    operation: 'Operation',
    detail: "@:{'common.scorecard.detail'}",
    indicator: 'Indikator',
    indicator_point: 'Bereiche für Verbesserungen',
    buyer_indicator_point: 'Bewertung Kommentar',
    status: 'Status',
    supported: 'Abgeschlossen',
    unsupported: 'Keine Aktion',
    progress: 'Status',
    advice: {
      text_line_1: 'Beginnen Sie mit der Verbesserung Ihrer ESG-Leistung anhand dieser Bewertung.',
      // text_line_2: "",
      text_line_3: 'legen Sie mit „Verbesserungsplan erstellen“ Ziele für die Erledigung der',
      text_line_4: 'eingegangenen Hinweise fest.',
      text_line_5: 'Den Fortschritt können Sie in der Grafik links sehen.',
      text_line_6: 'Wenn Sie eine Neubewertung beantragen möchten,',
      contact: 'Kontaktieren Sie uns',
      please_contact_us: ' bitte.',
    },
    sub_section_title_1: 'Verbesserungsplan in Arbeit',
    no_data_display: 'Es sind keine Daten verfügbar',
    // sub_section_title_2: "",
    buyer_sub_section_title_2: 'Kommentar zur unvollständigen Bewertung',
    operation_link_text: 'Verbesserungsplan erstellen',
    // add_advice: "",
    // sub_section_title_3: "",
    buyer_sub_section_title_3: 'Kommentar zur abgeschlossenen Bewertung',
    // revaluation_request: "",
    cautionary_note: 'Möchten Sie eine Neubewertung auf der Grundlage Ihres abgeschlossenen Verbesserungsplans beantragen?',
    asterisked_text: 'Wenn Sie eine Neubeurteilung beantragen möchten, tun Sie dies bitte über das Kontaktformular.',
    submit_btn_text: 'Erneute Bewertung beantragen',
    table_state: 'tableState',
    select_a_file: 'Wählen Sie eine Datei',
    attached_file: 'Datei anhängen',
    notes: 'Anmerkungen',
    created_improvement_plan: 'Einen Verbesserungsplan erstellen',
    error_file_upload: 'Fehler beim Hochladen der Datei aufgetreten',
    failed_to_create: 'Die Erstellung eines Verbesserungsplans ist fehlgeschlagen. Bitte versuchen Sie, die Seite zu aktualisieren.',
    no_data_found: 'Es wurden keine Daten zur Verbesserung gefunden.',
    file_upload: {
      filesize_max: 'Bitte wählen Sie Dateien mit weniger als 10 MB.',
      max_files: 'Sie können bis zu 10 Dateien hochladen.',
      confirmation_of_deletion: 'Möchten Sie diese Datei löschen?',
    },
    // create_improvement_plan: "",
    no_data_improvement_plan: 'Es sind derzeit keine Verbesserungen geplant.',
  },
  buyer_improvementplans: {
    flag: 'Flagge',
    memo: 'Memo',
    flag_on: 'Eine Flagge setzen',
    flag_off: 'Flagge entfernen',
    panel: {
      title: 'Unternehmensinformationen / Memo',
      company_memo: 'Memo der Firma',
      latest_memo: 'Letztes Memo',
      no_memo: 'Es sind noch keine Memos vorhanden.',
      check_list: 'Checkliste',
      memo_list: 'Memo-Liste',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: 'Zurück zur Liste',
    action_cases: 'Fälle',
    no_improvements: 'Keine Bereiche für Verbesserungen vorgeschlagen',
    confirm_delete_memo: 'Sind Sie sicher, dass Sie dieses Memo löschen möchten?',
    confirm_delete_memo_title: 'Memo löschen',
    // display_only_is_marked: "",
    create_memo: 'Ein Memo erstellen',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
